import React from 'react';
import { Card } from '../ui/Card';
export function KpiCardsSkeleton() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-253">
      {[1, 2, 3, 4].map(i => <Card key={i} className="p-5 border-slate-200" data-id="element-254">
          <div className="flex items-center justify-between mb-4" data-id="element-255">
            <div className="h-4 w-24 bg-slate-200 rounded animate-pulse" data-id="element-256"></div>
            <div className="h-5 w-12 bg-slate-200 rounded-full animate-pulse" data-id="element-257"></div>
          </div>
          <div className="h-8 w-16 bg-slate-200 rounded mb-2 animate-pulse" data-id="element-258"></div>
          <div className="h-3 w-32 bg-slate-100 rounded animate-pulse" data-id="element-259"></div>
        </Card>)}
    </div>;
}
export function LeadTableSkeleton() {
  return <Card className="overflow-hidden" data-id="element-260">
      <div className="overflow-x-auto" data-id="element-261">
        <table className="w-full text-sm text-left" data-id="element-262">
          <thead className="bg-slate-50/80 border-b border-slate-200" data-id="element-263">
            <tr data-id="element-264">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => <th key={i} className="px-4 py-3" data-id="element-265">
                  <div className="h-4 w-20 bg-slate-200 rounded animate-pulse" data-id="element-266"></div>
                </th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-267">
            {[1, 2, 3, 4, 5].map(row => <tr key={row} data-id="element-268">
                <td className="px-4 py-4" data-id="element-269">
                  <div className="h-4 w-32 bg-slate-200 rounded animate-pulse" data-id="element-270"></div>
                </td>
                <td className="px-4 py-4" data-id="element-271">
                  <div className="h-4 w-24 bg-slate-100 rounded animate-pulse" data-id="element-272"></div>
                </td>
                <td className="px-4 py-4" data-id="element-273">
                  <div className="h-4 w-28 bg-slate-100 rounded animate-pulse" data-id="element-274"></div>
                </td>
                <td className="px-4 py-4" data-id="element-275">
                  <div className="h-4 w-20 bg-slate-100 rounded animate-pulse" data-id="element-276"></div>
                </td>
                <td className="px-4 py-4" data-id="element-277">
                  <div className="h-4 w-20 bg-slate-100 rounded animate-pulse" data-id="element-278"></div>
                </td>
                <td className="px-4 py-4" data-id="element-279">
                  <div className="h-4 w-20 bg-slate-100 rounded animate-pulse" data-id="element-280"></div>
                </td>
                <td className="px-4 py-4" data-id="element-281">
                  <div className="h-5 w-16 bg-slate-100 rounded-md animate-pulse" data-id="element-282"></div>
                </td>
                <td className="px-4 py-4" data-id="element-283">
                  <div className="flex flex-col gap-2" data-id="element-284">
                    <div className="h-4 w-40 bg-slate-200 rounded animate-pulse" data-id="element-285"></div>
                    <div className="h-3 w-24 bg-slate-100 rounded animate-pulse" data-id="element-286"></div>
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-287">
                  <div className="flex gap-1" data-id="element-288">
                    <div className="h-5 w-20 bg-slate-200 rounded-full animate-pulse" data-id="element-289"></div>
                  </div>
                </td>
                <td className="px-4 py-4 text-right" data-id="element-290">
                  <div className="flex justify-end gap-2" data-id="element-291">
                    <div className="h-8 w-8 bg-slate-100 rounded animate-pulse" data-id="element-292"></div>
                    <div className="h-8 w-8 bg-slate-100 rounded animate-pulse" data-id="element-293"></div>
                    <div className="h-8 w-8 bg-slate-100 rounded animate-pulse" data-id="element-294"></div>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Card>;
}